import HighCharts from './HighCharts';

export default HighCharts;
